import * as React from 'react'
import { Container } from '../Container'
import { Button } from '../Button'

export const ApplyNowSection: React.FC = () => {
  return (
    <section
      style={{
        backgroundColor: '#ea3616',
      }}
    >
      <Container className="text-center text-white">
        <h1 className="text-white">Interested? Apply Now.</h1>
        <p>We’re growing fast — explore and apply for our open brake tech positions now.</p>
        <div className="mt-6">
          <a href={`https://apply.workable.com/nubrakes`}>
            <Button
              className="px-12"
              style={{
                backgroundColor: '#861f0c',
              }}
            >
              Apply Now
            </Button>
          </a>
        </div>
      </Container>
    </section>
  )
}
